import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from "react";
import CloseSmall from "monday-ui-react-core/dist/icons/CloseSmall";
import { StyledAshbyInternalEmployeeLink } from "./ashby-internal-employee-link.scss";
import { ASHBY_INTERNAL_EMPLOYEE_TEXTS } from "./constants";
import { ASHBY_INTERNAL_PORTAL_URL } from "../../careers-constants";
import { shouldShowInternalTag } from "/services/careers/internal-positions-service";
import { trackEvent } from "/services/bigbrain-service";
import { CAREER_PAGE_CLICK, CAREER_KIND_EMPLOYEE_AT_MONDAY_LINK_CLICKED, CAREER_KIND_EMPLOYEE_AT_MONDAY_PORTAL_CLICKED } from "/constants/bigbrain-event-types";
// Internal-mobility / referral entry point for monday employees; mirrors the "Employee at monday.com?" affordance the Comeet widget renders on legacy postings.
const AshbyInternalEmployeeLink = ()=>{
    const [isMondayEmployee, setIsMondayEmployee] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    useEffect(()=>{
        setIsMondayEmployee(shouldShowInternalTag());
    }, []);
    const openModal = useCallback(()=>{
        trackEvent(CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_EMPLOYEE_AT_MONDAY_LINK_CLICKED
        });
        setIsModalOpen(true);
    }, []);
    const closeModal = useCallback(()=>setIsModalOpen(false), []);
    const trackPortalClick = useCallback(()=>{
        trackEvent(CAREER_PAGE_CLICK, {
            kind: CAREER_KIND_EMPLOYEE_AT_MONDAY_PORTAL_CLICKED
        });
        closeModal();
    }, [
        closeModal
    ]);
    useEffect(()=>{
        if (!isModalOpen) return undefined;
        const onKeyDown = (event)=>{
            if (event.key === "Escape") closeModal();
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>document.removeEventListener("keydown", onKeyDown);
    }, [
        isModalOpen,
        closeModal
    ]);
    if (!isMondayEmployee) return null;
    const text = ASHBY_INTERNAL_EMPLOYEE_TEXTS;
    return /*#__PURE__*/ _jsxs(StyledAshbyInternalEmployeeLink, {
        children: [
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: "employee-link",
                onClick: openModal,
                children: text.trigger
            }),
            isModalOpen && /*#__PURE__*/ _jsx("div", {
                className: "employee-modal-overlay",
                role: "dialog",
                "aria-modal": "true",
                onClick: closeModal,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "employee-modal",
                    onClick: (event)=>event.stopPropagation(),
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "employee-modal-close",
                            "aria-label": text.closeAriaLabel,
                            onClick: closeModal,
                            children: /*#__PURE__*/ _jsx(CloseSmall, {})
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "employee-modal-title",
                            children: text.modalTitle
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "employee-modal-body",
                            children: [
                                text.modalBodyPrefix,
                                /*#__PURE__*/ _jsx("a", {
                                    className: "employee-modal-cta",
                                    href: ASHBY_INTERNAL_PORTAL_URL,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: trackPortalClick,
                                    children: text.modalCta
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export default AshbyInternalEmployeeLink;
